import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6fda4668")

_pushScopeId("data-v-6fda4668")
const _hoisted_1 = { class: "detail-instructions-view" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "detail-instructions-title-view-area" }, [
  /*#__PURE__*/_createVNode("div", { class: "detail-instructions-title-view" }, " 作り方 ")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DetailInstructionItem = _resolveComponent("DetailInstructionItem")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.instructions, (item) => {
      return (_openBlock(), _createBlock(_component_DetailInstructionItem, {
        key: item.id,
        step: item.id,
        description: item.item.description,
        imageUrl: _ctx.getImage(item.item.images),
        dlMenuId: item.item.dlMenuId,
        note: item.item.note,
        lastItem: item.lastItem,
        applianceCategory: _ctx.applianceCategory,
        applianceCategoryId: _ctx.applianceCategoryId,
        applianceData: _ctx.applianceData,
        update: _ctx.update,
        recipeAttachmenList: _ctx.recipeAttachmenList,
        attachmentList: _ctx.attachmentList,
        pageScrollTop: _ctx.pageScrollTop,
        onSetInstructionItemPosition: _ctx.setInstructionItemPosition,
        onClickBistroSend: _ctx.clickBistroSend,
        onClickBistroSendLink: _ctx.clickBistroSendLink
      }, null, 8, ["step", "description", "imageUrl", "dlMenuId", "note", "lastItem", "applianceCategory", "applianceCategoryId", "applianceData", "update", "recipeAttachmenList", "attachmentList", "pageScrollTop", "onSetInstructionItemPosition", "onClickBistroSend", "onClickBistroSendLink"]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
})